import { Container } from 'react-bootstrap';
import LogsList from '../components/LogsList';

const Logs = () => {
  return (
    <Container className="mt-4">
      <h2>Logs</h2>
      <LogsList />
    </Container>
  );
};

export default Logs;
